import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Chart, registerables } from 'chart.js/auto';
import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import {
  LoginModel,
  MainDepartment,
  Stores,
} from 'src/app/Models/ApplicationModels';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';
import { AdminBreadcrumbsService } from 'src/app/rcs/admin-module/admin-services/admin-breadcrumbs.service';
import { OverrideStatus } from 'src/app/enum/enum';
import { ProductionCycle, ProductionCycleSchedule } from 'src/app/rcs/admin-module/company-config/WeekColors/models/week-color.model';
import { WeekColorService } from 'src/app/rcs/admin-module/company-config/WeekColors/services/week-color.service';
import { ReportsV3ApiService } from '../../services/reports-v3-api.service';

@Component({
  selector: 'app-production-overview-dashboard-v3',
  templateUrl: './production-overview-dashboard-v3.component.html',
  styleUrls: ['./production-overview-dashboard-v3.component.css'],
})
export class ProductionOverviewDashboardV3Component {
  @ViewChild('totalItem') totalItem!: ElementRef;
  @ViewChild('totalItemValue') totalItemValue!: ElementRef;
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  @ViewChild('empElement') empElement!: ElementRef<HTMLElement>;
  defaultStore: number = 0;
  storeId: any = 0;
  deptID: string = '';
  startDate: any;
  endDate: any;
  private charts: Chart[] = [];
  totalItemChart: any;
  totalItemValueChart: any;
  userInfo: LoginModel = new LoginModel();
  mainDepartmentList: Array<MainDepartment> = [];
  dashboardDetails: any;
  getDetailsObj: any = {};
  isStoreNull: boolean = false;
  isNoDataFound: boolean = false;
  isTableData: boolean = false;
  isStoreData: boolean = false;
  isDeptData: boolean = false;
  isEmpData: boolean = false;
  isBrandData: boolean = false;
  headerCheckboxSelected: boolean = false;
  qtyTotal: number = 0;
  deptQty: number = 0;
  deptPrice: number = 0;
  empQty: number = 0;
  storePrices: number = 0;
  storeQty: number = 0;
  isSingleStore: boolean = false;
  selectedDepartmentIds: number[] = [];
  @Input() max: any;
  maxDate = new Date();
  tableDataTotalQty: number = 0;
  public daterange: any = {};
  storeName: string = 'All stores';
  deptName: string = 'All departments';
  deptNames: Array<string> = [];
  dashboardTabledata: any = [];
  StoreNames: string | any = [];
  tempToggleOption: number = 1;
  sortDirection: string = 'asc';
  stores: Array<Stores> = [];
  isLoading: boolean = false;
  reportHasRun: boolean = false;
  mainStats = {
    qty: 0,
    price: 0,
    categoryCnt: 0,
  };

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  weekColorHeaderSelected: boolean = false;
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  weekColorSchedule: Array<ProductionCycleSchedule> = [];
  productionCycleId: number = 0;
  showWeekColor: boolean = true;
  activeStatus: boolean | null = null;
  activeStatusLabel: string = 'All Items';

  constructor(
    private datepipe: DatePipe,
    private masterservice: MasterDataSeriveService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private weekColorService: WeekColorService,
    private reportsV3Service: ReportsV3ApiService
  ) {
    this.maxDate.setDate(this.maxDate.getDate());
  }

  async ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      {
        crumbName: 'Production Overview',
        link: '/admin/home/v3/production-overview',
      },
    ]);

    this.startDate = moment();
    this.endDate = moment();
    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (this.userInfo as any)?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    this.getMainDepartments();
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
  }

  onDeptIdSelection() {
    this.deptID = this.selectedDepartmentIds.join(',');
  }

  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
    },
    opens: 'left',
  };

  public selectedDate(value: any, datepicker?: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  getStores() {
    let store = localStorage.getItem('storeId')!;
    this.defaultStore = parseInt(store);
    let user = this.masterservice.getUserDetailsFromStorage();
    this.masterservice.getallstores(user.companyID).subscribe((res) => {
      if (Array.isArray(res)) {
        for (let item of res) {
          this.stores.push(item);
        }
      }
    });
  }

  sortByDepartment(col: string) {
    if (col === 'dept') {
      this.dashboardTabledata.sort(
        (a: { department: string }, b: { department: string }) => {
          if (this.sortDirection === 'asc') {
            return a.department.localeCompare(b.department);
          } else {
            return b.department.localeCompare(a.department);
          }
        }
      );
    } else {
      this.dashboardTabledata.sort((a: any, b: any) => {
        const qtyA = this.getQtyByStoreName(a, col);
        const qtyB = this.getQtyByStoreName(b, col);
        if (this.sortDirection === 'asc') {
          return qtyA - qtyB;
        } else {
          return qtyB - qtyA;
        }
      });
    }
  }

  toggleSortDirection(col: string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortByDepartment(col);
  }

  getQtyByStoreName(data: any, storeName: string): number {
    const item = data.qty.find((qtyItem: any) => qtyItem.store === storeName);
    return item ? item.qty : 0;
  }

  getMainDepartments() {
    this.masterservice.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => {
        this.mainDepartmentList = Response as MainDepartment[];
      },
      (err) => { }
    );
  }

  updateChart() {
    this.storeId = parseInt(this.storeId);
    if (!this.isTableData) {
      this.destroyCharts();
      this.getAllDashboardDetails();
    } else {
      this.getDashboardTableDetails();
    }
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;
    if (this.headerCheckboxSelected) {
      this.selectedDepartmentIds = this.mainDepartmentList.map(
        (goal) => goal.departmentId
      );
      this.deptNames = this.mainDepartmentList.map(
        (goal) => goal.departmentDescr
      );
      this.deptName = 'All Selected';
    } else {
      this.selectedDepartmentIds = [];
      this.deptNames = [];
      this.deptName = 'All departments';
    }
    if (this.selectedDepartmentIds.length) {
      this.deptID = this.selectedDepartmentIds.join(', ');
    } else {
      this.deptID = '0';
    }
  }

  selectAllStores() {
    this.storeName = 'All stores';
    this.storeId = 0;
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 1) {
      this.storeName = filterObj.storeName;
      this.storeId = filterObj.storeId;
    }
    if (option === 2) {
      const nameIndex = this.deptNames.findIndex(
        (item) => item === filterObj.departmentDescr
      );
      if (nameIndex !== -1) {
        this.deptNames.splice(nameIndex, 1);
      } else {
        this.deptNames.push(filterObj.departmentDescr);
      }
      const iDIndex = this.selectedDepartmentIds.indexOf(filterObj.departmentId);
      if (iDIndex !== -1) {
        this.selectedDepartmentIds.splice(iDIndex, 1);
      } else {
        this.selectedDepartmentIds.push(filterObj.departmentId);
      }
      if (this.selectedDepartmentIds.length === 0) {
        this.deptName = 'All departments';
        this.deptID = '0';
      } else if (this.selectedDepartmentIds.length === this.mainDepartmentList.length) {
        this.deptName = 'All Selected';
        this.deptID = this.selectedDepartmentIds.join(', ');
      } else if (this.deptNames.length === 1) {
        this.deptName = this.deptNames[0];
        this.deptID = this.selectedDepartmentIds.join(', ');
      } else {
        this.deptName = this.deptNames[0] + ' +' + `${this.deptNames.length - 1}`;
        this.deptID = this.selectedDepartmentIds.join(', ');
      }
      this.headerCheckboxSelected = this.selectedDepartmentIds.length === this.mainDepartmentList.length;
    }
    if (option == 5) {
      this.weekColor = filterObj.displayName;
      this.productionCycleId = filterObj.id;
    }
  }

  getDashboardTableDetails() {
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.reportsV3Service
      .getProductionOverviewTableV3(
        this.userInfo.companyID,
        this.storeId || 0,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId
      )
      .subscribe({
        next: (res: any) => {
          const storeNamesSet = new Set<string>();
          this.StoreNames = [];
          const dashboardDetail = res?.dashboardDetail ?? (Array.isArray(res) ? res : []);
          if (this.storeId && dashboardDetail.length > 0) {
            dashboardDetail.forEach((item: { userName: string }) => {
              storeNamesSet.add(item.userName);
            });
          } else {
            dashboardDetail.forEach((item: { storeName: string }) => {
              storeNamesSet.add(item.storeName);
            });
          }
          this.StoreNames = Array.from(storeNamesSet);
          if (this.StoreNames.length === 1) {
            this.isSingleStore = true;
          }
          this.dashboardTabledata = this.formateDashboardTableData(dashboardDetail);
          this.tableDataTotalQty = this.dashboardTabledata.reduce(
            (sum: any, dep: { qty: any[] }) =>
              sum + dep.qty.reduce((total, q) => total + q.qty, 0),
            0
          );
        },
        error: (err) => {
          this.isNoDataFound = true;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  async getAllDashboardDetails() {
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );

    this.reportsV3Service
      .getProductionOverviewDashboardV3(
        this.userInfo.companyID,
        this.storeId || 0,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId
      )
      .subscribe({
        next: (res: any) => {
          this.dashboardDetails = res as any[];
          if (
            this.dashboardDetails.department.length === 0 &&
            this.dashboardDetails.brand.length === 0 &&
            this.dashboardDetails.emp.length === 0
          ) {
            this.isNoDataFound = true;
          } else {
            this.isNoDataFound = false;
          }

          if (res.stats.length > 0) {
            this.mainStats = res.stats[0];
          } else {
            this.mainStats = { qty: 0, price: 0, categoryCnt: 0 };
          }

          if (this.dashboardDetails.store == null) {
            this.isStoreNull = true;
            this.storePrices = 0;
            this.storeQty = 0;
          } else {
            this.isStoreNull = false;
            this.storePrices = 0;
            this.storeQty = 0;
            for (let store of this.dashboardDetails.store) {
              this.storePrices += store.price;
              this.storeQty += store.qty;
            }
          }
          if (res.department.length === 0) {
            this.isDeptData = true;
          } else {
            this.isDeptData = false;
          }
          if (res.emp.length === 0) {
            this.isEmpData = true;
          } else {
            this.isEmpData = false;
          }
          if (res.brand.length === 0) {
            this.isBrandData = true;
          } else {
            this.isBrandData = false;
          }
          this.renderChart();

          if (this.dashboardDetails.department.length > 0) {
            this.deptPrice = 0;
            this.deptQty = 0;
            for (let dept of this.dashboardDetails.department) {
              this.deptQty += dept.qty;
              this.deptPrice += dept.price;
            }
          } else {
            this.deptPrice = 0;
            this.deptQty = 0;
          }
          if (this.dashboardDetails.emp.length > 0) {
            this.empQty = 0;
            for (let emp of this.dashboardDetails.emp) {
              this.empQty += emp.qty;
              if (!emp.userName) {
                emp.userName = '-';
              }
            }
          } else {
            this.empQty = 0;
          }

          if (this.dashboardDetails.brand.length > 0) {
            this.qtyTotal = 0;
            for (let brand of this.dashboardDetails.brand) {
              this.qtyTotal += brand.qty;
            }
          } else {
            this.qtyTotal = 0;
          }

          if (this.dashboardDetails.store.length === 0) {
            this.isStoreData = true;
          } else {
            this.isStoreData = false;
          }
        },
        error: (err) => {
          this.isDeptData = true;
          this.isEmpData = true;
          this.isStoreData = true;
          this.isBrandData = true;
          this.isNoDataFound = true;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  renderChart() {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    let deptItem = new Chart('deptItemV3', {
      type: 'bar',
      data: {
        labels: this.dashboardDetails.department.map(
          (item: { departmentDescr: any }) => item.departmentDescr
        ),
        datasets: [
          {
            label: 'No. of items',
            barThickness: 25,
            data: this.dashboardDetails.department.map(
              (item: { qty: any }) => item.qty
            ),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -23 },
        },
        layout: { padding: { bottom: 0 } },
        scales: {
          y: { beginAtZero: true, border: { display: false }, title: { display: false, text: 'No. of Items' } },
          x: { beginAtZero: true, border: { display: false }, grid: { display: false } },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });

    let deptValue = new Chart('deptValueV3', {
      type: 'bar',
      data: {
        labels: this.dashboardDetails.department.map(
          (item: { departmentDescr: any }) => item.departmentDescr
        ),
        datasets: [
          {
            label: 'Value in $',
            barThickness: 25,
            data: this.dashboardDetails.department.map(
              (item: { price: any }) => item.price
            ),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -23 },
        },
        layout: { padding: { bottom: 0 } },
        scales: {
          y: { beginAtZero: true, title: { display: false, text: 'Value in $' }, border: { display: false } },
          x: { grid: { display: false }, border: { display: false } },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });

    let productivityEmp = new Chart('productivityEmpV3', {
      type: 'bar',
      data: {
        labels: this.dashboardDetails.emp.map((item: { userName: any }) =>
          item.userName ? item.userName : '-'
        ),
        datasets: [
          {
            label: 'No. of items (Actual)',
            barThickness: 25,
            data: this.dashboardDetails.emp.map(
              (item: { qty: any }) => item.qty
            ),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -23 },
        },
        layout: { padding: { bottom: 0 } },
        scales: {
          y: { beginAtZero: true, title: { display: false, text: 'No. of items' }, border: { display: false } },
          x: { stacked: true, grid: { display: false }, border: { display: false } },
        },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    let productivityBrand = new Chart('productivityBrandV3', {
      type: 'bar',
      data: {
        labels: this.dashboardDetails.brand.map(
          (item: { brandDescr: any }) => item.brandDescr
        ),
        datasets: [
          {
            label: 'No. of items',
            barThickness: 25,
            data: this.dashboardDetails.brand.map(
              (item: { qty: any }) => item.qty
            ),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          tooltip: { enabled: true },
          datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -23 },
        },
        layout: { padding: { bottom: 0 } },
        scales: {
          x: { stacked: true, border: { display: false }, grid: { display: false } },
          y: { stacked: true, border: { display: false }, title: { display: false, text: 'No. of items' } },
        },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    if (this.dashboardDetails.store != null) {
      this.totalItemValueChart = new Chart('totalItemValueV3', {
        type: 'doughnut',
        data: {
          labels: this.dashboardDetails.store.map(
            (item: { storeName: any }) => item.storeName
          ),
          datasets: [
            {
              label: 'Total Item Value',
              data: this.dashboardDetails.store.map(
                (item: { price: any }) => item.price
              ),
              backgroundColor: Array.from(
                { length: this.dashboardDetails.store.length },
                () => this.getRandomColor()
              ),
              borderRadius: 7,
              borderWidth: 3,
            },
          ],
        },
        options: {
          cutout: '55%',
          plugins: {
            legend: { display: true, position: 'right', labels: { usePointStyle: true } },
            datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -25 },
          },
          layout: { padding: { bottom: 0, top: 10, left: 0, right: 40 } },
          scales: { x: { display: false }, y: { display: false } },
          maintainAspectRatio: false,
          responsive: true,
        },
      });

      this.totalItemChart = new Chart('totalItemV3', {
        type: 'doughnut',
        data: {
          labels: this.dashboardDetails.store.map(
            (item: { storeName: any }) => item.storeName
          ),
          datasets: [
            {
              label: 'Total Item',
              data: this.dashboardDetails.store.map(
                (item: { qty: any }) => item.qty
              ),
              backgroundColor: Array.from(
                { length: this.dashboardDetails.store.length },
                () => this.getRandomColor()
              ),
              borderRadius: 7,
              borderWidth: 3,
            },
          ],
        },
        options: {
          cutout: '55%',
          plugins: {
            legend: { display: true, position: 'right', labels: { usePointStyle: true } },
            tooltip: { enabled: true },
            datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -25 },
          },
          layout: { padding: { bottom: 0, top: 10, left: 0, right: 40 } },
          scales: { x: { display: false }, y: { display: false } },
          maintainAspectRatio: false,
          responsive: true,
          aspectRatio: 3,
        },
      });
    }
    this.charts = [
      deptItem,
      deptValue,
      productivityEmp,
      productivityBrand,
      this.totalItemValueChart,
      this.totalItemChart,
    ];
  }

  destroyCharts() {
    this.charts.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });
    this.charts = [];
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  toggleTableOrGraph(value: number) {
    if (this.tempToggleOption !== value) {
      this.tempToggleOption = value;
      if (value == 1) {
        this.isTableData = false;
      } else {
        this.isTableData = true;
      }
    }
  }

  calculateColumnTotal(store: string): number {
    const total = this.dashboardTabledata.reduce(
      (sum: any, dashboardTabledata: { qty: any[] }) => {
        let storeDataArray;
        if (this.storeId) {
          storeDataArray = dashboardTabledata.qty.filter(
            (item) => item.UserName === store
          );
        } else {
          storeDataArray = dashboardTabledata.qty.filter(
            (item) => item.store === store
          );
        }
        const storeQty = storeDataArray.reduce(
          (storeSum, item) => storeSum + item.qty,
          0
        );
        return sum + storeQty;
      },
      0
    );
    return total;
  }

  calculateRowTotal(row: any): number {
    const rowTotal = row.reduce((total: any, qty: any) => total + qty.qty, 0);
    return rowTotal;
  }

  getDeptStoreWiseQty(deptData: any, store: string): number {
    let storeDataArray = deptData.qty.filter((item: any) => item.store === store);
    let totalQty = storeDataArray.reduce(
      (sum: any, item: { qty: any }) => sum + item.qty,
      0
    );
    return totalQty;
  }

  getDeptUserWiseQty(deptData: any, user: string): number {
    let storeDataArray = deptData.qty.filter((item: any) => item.UserName === user);
    let totalQty = storeDataArray.reduce(
      (sum: any, item: { qty: any }) => sum + item.qty,
      0
    );
    return totalQty;
  }

  formateDashboardTableData(dashboardDetails: any[]): any[] {
    return dashboardDetails.reduce((result, item) => {
      const departmentKey = item.departmentDescr;
      const categoryName = item.categoryName;
      const storeName = item.storeName;
      const catQty = item.catQty;
      const userName = item.userName;

      const department = result.find(
        (dep: { department: any }) => dep.department === departmentKey
      );

      if (!department) {
        result.push({ department: departmentKey, qty: [], categories: [] });
      }

      const departmentIndex = result.findIndex(
        (dep: { department: any }) => dep.department === departmentKey
      );
      const category = result[departmentIndex].categories.find(
        (cat: { cname: any }) => cat.cname === categoryName
      );

      if (!category) {
        result[departmentIndex].categories.push({ cname: categoryName, qty: [] });
      }

      const categoryIndex = result[departmentIndex].categories.findIndex(
        (cat: { cname: any }) => cat.cname === categoryName
      );
      let storeIndex;
      if (this.storeId) {
        storeIndex = result[departmentIndex].qty.findIndex(
          (q: { UserName: any }) => q.UserName === storeName
        );
      } else {
        storeIndex = result[departmentIndex].qty.findIndex(
          (q: { store: any }) => q.store === storeName
        );
      }

      if (storeIndex === -1) {
        result[departmentIndex].qty.push({ store: storeName, qty: catQty, UserName: userName });
      } else {
        result[departmentIndex].qty[storeIndex].qty += catQty;
      }

      result[departmentIndex].categories[categoryIndex].qty.push({
        store: storeName,
        qty: catQty,
        UserName: userName,
      });

      return result;
    }, []);
  }

  getWeekColors() {
    let user = this.masterservice.getUserDetailsFromStorage();
    this.weekColorService.getProductionCycles(user.companyID).subscribe((res) => {
      this.weekColorsList = res as ProductionCycle[];
      this.weekColorsList = this.weekColorsList.filter(
        (item) => item.status === OverrideStatus.Active
      );
    });
  }

  toggleAllColors() {
    this.weekColorHeaderSelected = !this.weekColorHeaderSelected;
  }

  selectAllcolors() {
    this.weekColor = 'All Week Colors';
    this.productionCycleId = 0;
  }

  runReport() {
    this.reportHasRun = true;
    this.updateChart();
  }

  setActiveStatus(status: boolean | null, label: string) {
    this.activeStatus = status;
    this.activeStatusLabel = label;
  }
}
